// Typelizer digest 088afee1c4caaed9ea30cb9195cb0cd2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /farms */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/farms', {}, options),
    method: 'post',
  }),

  /** PATCH /farms/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/farms/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /farms/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/farms/:id', params, options),
    method: 'delete',
  }),
}
